import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  Select,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useHeaderStyles from "../../test/testStyle/gateStyle/headerStyle";
import { useLanguages } from "../../../context/LanguagesContext";

function InstructionPopup({
  openInstructions,
  handleCloseInstructions,
  examInstructions,
  examId,
  examInstructionsHindi,
}) {
  const classes = useHeaderStyles();
  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { languages, handleChange, selectedLanguage, fetchLanguagesData } =
    useLanguages();

  useEffect(() => {
    if (examId) {
      fetchLanguagesData(examId);
    }
  }, [examId]);

  return (
    <Dialog
      open={openInstructions}
      onClose={handleCloseInstructions}
      maxWidth={false}
      fullScreen={isTabletOrMobile}
      PaperProps={{
        style: {
          width: isTabletOrMobile ? "100%" : "80vw",
          height: isTabletOrMobile ? "100%" : "80vh",
          margin: isTabletOrMobile ? 0 : "auto",
        },
      }}
    >
      {/* <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Exam Instructions
        <IconButton aria-label="close" edge="end">
          <Select
            value={selectedLanguage}
            onChange={handleChange}
            size="small"
            style={{marginRight: 10}}
          >
            {languages?.map((l, i) => (
              <MenuItem key={i} value={l.value}>
                {l.label}
              </MenuItem>
            ))}

          </Select>
          <CloseIcon onClick={handleCloseInstructions} />
        </IconButton>
      </DialogTitle> */}

      <DialogTitle
        sx={{
          backgroundColor: "#1374aa",
          p: 0, // removes default padding
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: "16px",
            paddingRight: "16px",
            color: "white",
          }}
        >
          <span>Exam Instructions</span>
          <div>
            <IconButton aria-label="close" edge="end">
              <Select
                value={selectedLanguage}
                onChange={handleChange}
                size="small"
                style={{ marginRight: 20,background:'white',height:'30px'}}
              >
                {languages?.map((l, i) => (
                  <MenuItem key={i} value={l.value}>
                    {l.label}
                  </MenuItem>
                ))}
              </Select>
            </IconButton>
            <IconButton onClick={handleCloseInstructions} edge="end">
              <CloseIcon style={{ color: "white" }} />
            </IconButton>
          </div>
        </div>
      </DialogTitle>

      <DialogContent style={{ marginBottom: 20 }}>
        <DialogContentText className={classes.instructionsDialogContent}>
          <div
            dangerouslySetInnerHTML={{
              __html:
                selectedLanguage === "english"
                  ? examInstructions
                  : examInstructionsHindi,
            }}
          />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}

export default InstructionPopup;
